/**
 * delegation:submitted for a send on the classic socket lane (new task,
 * continuation, teammate). The composer gateway lane counts its own asks
 * (useComposerConverse), and a gateway ask that falls back to this lane was
 * never counted there — so every user send is counted exactly once, on
 * whichever lane carried it.
 *
 * A helper of its own because both send forks call it and sendMessage already
 * imports teammateSend (importing back would close a module cycle).
 */

import { ANALYTICS_EVENTS } from "@bash/shared";
import { captureV1, clientSurface } from "@/lib/analytics-v1";

export function captureDelegationSubmitted(
  taskId: string,
  content: string,
  traceId: string,
  send: { silent: boolean; isDeposit: boolean }
): void {
  // Not a person's ask: a silent send is the app's own (a resume, CONTINUE_PROMPT)
  // and the server does not accept it either; a deposit files things, no turn runs.
  if (send.silent || send.isDeposit) return;
  captureV1(ANALYTICS_EVENTS.DELEGATION_SUBMITTED, {
    task_id: taskId,
    trace_id: traceId,
    surface: clientSurface(),
    input_mode: "typed",
    message_length: content?.length || 0,
  });
}
